require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-ai-powered-translations-with-new-traduality-partnership.json") })
        }
      }, "path---articles-ai-powered-translations-with-new-traduality-partnership");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-ai-powered-translations-with-new-traduality-partnership!./.cache/json/articles-ai-powered-translations-with-new-traduality-partnership.json
// module id = 1553
// module chunks = 231608221292675